export default {
  musicalGenres: 'Géneros musicales',
  seeMore: 'Ver más',
  artists: 'Artistas',
  songs: 'Canciones',
  topMusicGenres: 'Top géneros musicales',
  additionalGenres: 'Géneros adicionales',
  topArtists: 'Top Artistas',
  additionalArtists: 'Artistas Adicionales',
  topSongs: 'Top Canciones',
  additionalSongs: 'Canciones Adicionales',
  likes: 'Gustos',
  peopleLikes: 'Gustos de las personas',
  additionalLikes: 'Gustos adicionales',
  peoplePerJourneyStatus: 'Personas por estado del Journey'
}
